import { useController, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { InputElementProps, MonetaryInput, MonetaryInputProps } from '../../UI';
import { CashAccountFormValues } from '../types';

interface CashAccountEstimatedValueInputProps
  extends Pick<InputElementProps, 'required' | 'autoFocus'>,
    Pick<MonetaryInputProps, 'helperText'> {
  className?: string;
}

export function CashAccountEstimatedValueInput({ required = true, ...props }: CashAccountEstimatedValueInputProps) {
  const { t: tForm } = useTranslation('form');
  const { control } = useFormContext<CashAccountFormValues>();
  const {
    field,
    formState: { errors },
  } = useController<CashAccountFormValues, 'estimatedValue'>({
    control,
    rules: { required },
    name: 'estimatedValue',
  });

  return (
    <MonetaryInput
      {...field}
      {...props}
      status={errors.estimatedValue ? 'errored' : 'normal'}
      label={tForm('cash-account-estimated-value-input-label')}
      inputProps={{
        placeholder: required ? tForm('general-required-placeholder') : '',
      }}
    />
  );
}
